import { array, eq, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { NewRoutingRuleResult } from '@mews-commander/data-access';
import { BookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';

export const getRoutingRuleAssignments = (result: NewRoutingRuleResult, index: number) => {
    const routingRuleId = result.routingRules?.[index].id;
    if (!routingRuleId) {
        return [];
    }

    return result.routingRuleAssignments?.filter((assignment) => assignment.routingRuleId === routingRuleId) ?? [];
};

export const getRoutingRuleServices = (
    result: NewRoutingRuleResult,
    index: number,
    bookableServices: BookableService[]
) => {
    const routingRuleAssignments = getRoutingRuleAssignments(result, index);
    const bookableRoutingRuleAssignments = routingRuleAssignments.filter((assignment) =>
        bookableServices.some((service) => service.id === assignment.serviceId)
    );

    return pipe(
        bookableRoutingRuleAssignments,
        array.uniq(
            eq.struct({
                serviceId: string.Eq,
                serviceName: string.Eq,
            })
        ),
        array.map((assignment) => ({
            serviceId: assignment.serviceId,
            serviceName: assignment.serviceName,
        }))
    );
};
